import { render, staticRenderFns } from "./LeftMenuProject.vue?vue&type=template&id=5b8df8ff"
import script from "./LeftMenuProject.vue?vue&type=script&lang=js"
export * from "./LeftMenuProject.vue?vue&type=script&lang=js"
import style0 from "./LeftMenuProject.vue?vue&type=style&index=0&id=5b8df8ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports